export { Datacenter, ErrorSource } from '@datadog/browser-core';
export { datadogRum } from './boot/rum.entry';
export { RumEventCategory, } from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/index.js
// module id = An4P
// module chunks = 1